import * as z from 'zod';

import { DISPLAY_SETTING_ACTIONS } from 'src/features/systems/utils/displaySettingConstants';
import { SYSTEM_SETTINGS_CATEGORY } from 'src/features/systems/utils/types';

export type DisplaySettingValueSchemaValues = z.infer<typeof displaySettingValue>;
export type DisplaySettingCreateFormSchemaValues = z.infer<typeof displaySettingCreateFormSchema>;
export type DisplaySettingFormSchemaValues = z.infer<typeof displaySettingFormSchema>;

const displaySettingValue = z.object({
    title: z.string().optional(),
    subtitle: z.string().optional(),
    title_color: z.string().optional(),
    subtitle_color: z.string().optional(),
});

export const displaySettingCreateFormSchema = z.object({
    category: z.enum(SYSTEM_SETTINGS_CATEGORY),
    code: z.string(),
    value: displaySettingValue,
});

const displaySettingFormSchemaShape = Object.fromEntries(
    DISPLAY_SETTING_ACTIONS.map((action) => [action, displaySettingValue]),
) as Record<(typeof DISPLAY_SETTING_ACTIONS)[number], typeof displaySettingValue>;

export const displaySettingFormSchema = z.object(displaySettingFormSchemaShape);
